import { browser } from '$app/environment';
import { api } from '$lib/api';
import { Track } from '$lib/models/track';
import { AssetType } from './asset';

let cachedTracks: Track[] = [];
let cachedSfxs: Track[] = [];
let cachedIntros: Track[] = [];

export async function getRandomAsset(type: AssetType): Promise<Track> {
  if (!browser) {
    return new Track();
  }
  switch (type) {
    case AssetType.Track:
      return getRandomTrack();
    case AssetType.SFX:
      return getRandomSfx();
    case AssetType.Intro:
      return getRandomIntro();
  }
  return new Track();
}

export async function getRandomTrack(): Promise<Track> {
  if (!browser) {
    return new Track();
  }
  if (cachedTracks.length === 0) {
    await refreshTracks();
  }
  const track = cachedTracks.shift();
  if (!track) {
    throw new Error('No random tracks found');
  }
  return track;
}

export async function getRandomSfx(): Promise<Track> {
  if (!browser) {
    return new Track();
  }
  if (cachedSfxs.length === 0) {
    await refreshSfxs();
  }
  const sfx = cachedSfxs.shift();
  if (!sfx) {
    throw new Error('No random sfx found');
  }
  return sfx;
}

export async function getRandomIntro(): Promise<Track> {
  if (!browser) {
    return new Track();
  }
  if (cachedIntros.length === 0) {
    await refreshIntros();
  }
  const intro = cachedIntros.shift();
  if (!intro) {
    throw new Error('No random intros found');
  }
  return intro;
}

async function refreshTracks(): Promise<void> {
  cachedTracks = await api<Track[]>(fetch, '/v1/tracks/random');
}

async function refreshSfxs(): Promise<void> {
  cachedSfxs = await api<Track[]>(fetch, '/v1/sfx/random');
}

async function refreshIntros(): Promise<void> {
  cachedIntros = await api<Track[]>(fetch, '/v1/intros/random');
}
